import { useState } from 'react'
import { PlusCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { useToast } from '@/components/ui/use-toast'
import useMemoryStore from '@/stores/useMemoryStore'
import { MemoryForm } from './MemoryForm'

interface AddMemoryDialogProps {
  orgId: string
}

export const AddMemoryDialog = ({ orgId }: AddMemoryDialogProps) => {
  const [open, setOpen] = useState(false)
  const { addMemory, isSubmitting } = useMemoryStore()
  const { toast } = useToast()

  const handleSubmit = async (values: { content: string }) => {
    try {
      await addMemory(orgId, values)
      toast({
        title: 'Success',
        description: 'Memory added successfully.',
      })
      setOpen(false)
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: 'Failed to add memory. Please try again.',
      })
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <PlusCircle className="mr-2 h-4 w-4" /> Add Memory
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add New Memory</DialogTitle>
          <DialogDescription>
            Record a new memory for this organization.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <MemoryForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
